import { render, staticRenderFns } from "./BadFit.vue?vue&type=template&id=5291722b&scoped=true"
import script from "./BadFit.vue?vue&type=script&lang=ts"
export * from "./BadFit.vue?vue&type=script&lang=ts"
import style0 from "./BadFit.vue?vue&type=style&index=0&id=5291722b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291722b",
  null
  
)

export default component.exports